import { FC, PropsWithChildren, useEffect, useState } from 'react';
import { MuiThemeProvider } from '@material-ui/core';

import { themeStore } from './themeStore';

// TODO: change to useSyncExternalStore when it is available
const useSyncExternalStore = (
  subscribe: (listener: () => void) => () => void,
  getSnapshot: () => unknown
) => {
  const [theme, setTheme] = useState(getSnapshot);

  useEffect(() => {
    const unsubscribe = subscribe(() => {
      setTheme(getSnapshot());
    });

    return () => unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return theme;
};

export const CorvaThemeProvider: FC<PropsWithChildren> = ({ children }) => {
  const currentTheme = useSyncExternalStore(themeStore.subscribe, themeStore.getTheme);
  return <MuiThemeProvider theme={currentTheme}>{children}</MuiThemeProvider>;
};
